// extracted by mini-css-extract-plugin
export var buttonContainer = "_94-1";
export var fontSizeSelect = "_94-3";
export var formatSelect = "_94-2";
export var formats = "_94-4";
export var hidden = "_94-5";
export var icon = "_94-6";
export var select = "_94-0";